import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import ModalFullscreen from '../../../ModalFullscreen';
import FullscreenModalHeader from '../../../BaseComponents/Header/components/FullscreenModalHeader';
const DesktopFlightFullscreen = ({ isOpen, onClose, isSelected, children }) => {
    const { DesktopFlightFullscreen: css } = useTheme('DesktopFlight');
    const { t } = useTranslation('FlightInfoModalContent');
    const title = t(isSelected ? 'You choose' : 'Select your bundle');
    return (React.createElement(ModalFullscreen, { className: css.modalFullscreen__content, classes: {
            root: css.modalFullscreen__root,
            header: css.modalFullscreen__header
        }, keepMounted: false, isOpen: isOpen, onClose: onClose, enableSwipeToClose: false, title: React.createElement(FullscreenModalHeader, { title: title, onClose: onClose, onClickBackward: onClose, className: css.modalFullscreen__fixed }) }, children));
};
export default DesktopFlightFullscreen;
